<style scoped>
.image-preview-container {
  height: 200px;
  overflow: hidden;
  text-align: center;
  background: #fff;
  width: 100%;
  margin: 0 auto;
}
.image-preview-container > img {
  height: 100%;
  width: auto;
  margin: 0 auto;
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  } 50% {
    transform: rotate(180deg);
  } to {
    transform: rotate(360deg);
  }
}
.demo-spin-col {
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}

.feed-list-page-template .ivu-avatar-large{
  width: 54px;
  height: 54px;
}

.multiline-ellipsis {
    display: block;
    display: -webkit-box;
    max-width: 400px;
    /* min-height: 25px; */
    line-height: 20px;
    /* margin: 0 auto; */
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>

<template>
    <div class="feed-list-page-template">
        <Row type="flex" justify="center">
            <Col :span="24" v-for="(item, k) in orderedFeeds" :key="k" v-if="item.type !== 'apply_volunteer' && item.type !== 'event_info'" :style="{marginBottom: '10px'}">
                <Card shadow :style="{borderRadius: '0'}" :padding="0">
                    <div class="feed-header" :style="{marginBottom: '10px', padding: '10px 10px 8px'}">

                        <Dropdown placement="bottom-start" style="float:right; padding-right:10px;" v-if="$store.state.user.info.user_type !== 'guest' && userIdCurrent!=userIdPublic">
                          <a style="padding:4px 10px; color: black;">
                            <Icon size="20" type="android-more-vertical"></Icon>
                          </a>
                          <DropdownMenu slot="list">
                            <DropdownItem>
                              <a @click="showReport(item.id)">Report this post</a>
                            </DropdownItem>
                          </DropdownMenu>
                        </Dropdown>

                        <a @click="viewResource(item)"><Avatar shape="square" size="large" :src="posterPreviewImage(item)" :style="{float:'left', marginRight: '10px'}" /></a>
                        <p @click="viewActivity(item)" class="multiline-ellipsis"><b>{{titlePreview(item)}}</b></p>
                        <small style="color:#aaa">
                           <timeago :since="item.updated_at"></timeago>
                           <b @click="viewResource(item)" v-if="section != 'journal' && section != 'group'">
                           &middot; {{item.careplan.title}}</b>
                        </small>
                    </div>
                    <div class="feed-content" style="position:relative">
                        <div @click="viewActivity(item)" class="image-preview-container" v-if="item.cover_photo" style="position:relative">
                          <span style="line-height:200px;position:absolute;width:20px;left:46vw;right:0;height:100vh;">
                            <Avatar v-if="item.type == 'attachment' && item.data.attachment_type == 'video'" icon="play" style="background:#6331ff"></Avatar>
                            <Avatar v-if="item.type == 'attachment' && item.data.attachment_type == 'slideshow'" icon="ios-monitor" style="background:#6331ff"></Avatar>
                            <Avatar v-if="item.type == 'attachment' && item.data.attachment_type == 'link'" icon="link" style="background:#6331ff"></Avatar>
                          </span>
                          <img :src="postPreviewImage(item)" width="100%" alt="IMAGE">
                        </div>
                        <div style="padding: 8px 10px 0" v-if="item.is_shareable">
                            <SharePost :item="item"></SharePost>
                        </div>
                        <div @click="viewActivity(item)" style="padding: 8px 10px 0;">
                           <p class="block-with-text" style="text-align: left;" v-html="contentDisplay(item)"></p>
                        </div>
                    </div>
                    <div class="feed-actions" :style="{padding: '8px 10px 8px'}">
                        <Row>
                            <!--<Col span="12">-->
                              <!--<p align="center" @click="bookmarkItem(item)">-->
                                <!--<span v-if="!item.bookmarked"><i class="far fa-bookmark"></i>&nbsp;Bookmark</span>-->
                                <!--<span v-if="item.bookmarked" style="color:#3f8dff"><i class="fas fa-bookmark"></i>&nbsp;Bookmarked</span>-->
                              <!--</p>-->
                            <!--</Col>-->
                            <Col span="24">
                              <router-link style="font-size:12px;color:rgb(170, 170, 170);" tag="span" :to="'/feed/' + item.id"><i class="far fa-comment"></i>&nbsp;
                                Comment {{ (item.activity_count > 0) ? "("+item.activity_count +")" : ''}}</router-link>
                              &nbsp;&nbsp;<span v-if="isShareableCapable() && item.is_shareable" @click="share(item)"><i class="fas fa-share-alt"></i>&nbsp;Share</span>
                            </Col>
                        </Row>
                    </div>
                </Card>
            </Col>
            <Col :span="24" v-if="orderedFeeds && orderedFeeds.length <= 0 && !feed.isLoading">
              <p align="center" style="padding:20px;color:#aaa">No activity to show</p>
            </Col>
            <Col :span="24" v-if="feed.isLoading">
              <Spin style="margin: 20px 0;">
                <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
                <div>Loading</div>
              </Spin>
            </Col>
        </Row>

        <ReportActivity :itemtype="'activity'" :activityid="activityid"></ReportActivity>
    </div>
</template>

<script>
import Utils from '@/utils.js'
import _ from 'lodash'
import WindowScrollEvent from 'vue-scroll-event/mixins/WindowOnScroll'
import SharePost from '@/components/SharePostComponent'
import ReportActivity from '@/components/ReportComponent';

export default {
  name: 'PublicFeedListComponent',
  mixins: [WindowScrollEvent],
  components: { SharePost, ReportActivity },
  props: {
    isPublic: {
      type: Boolean,
      default: false
    },
    section: {
      type: String,
      required: true,
      default: 'none'
    }
  },
  data() {
    return {
      activityid: ''
    }
  },
  methods: {
    showReport: function(activityid) {
      this.activityid=activityid;
      this.$store.commit('user/setReportThisId', activityid);
      this.$store.commit('user/setShowStepsActivity', true);
    },
    isShareableCapable() {
      return (!navigator.share) ? false : true;
    },
    share(act) {
      let desc = '';
      switch (act.type) {
        case "attachment":
          desc = act.data.text;
          break;
        case "trivia":
          desc = act.data.text;
          break;
        case "reveal":
          desc = act.data.question;
          break;
        default:
          desc = act.data.tip.replace(/(<([^>]+)>)/gi, '')
          break;
      }

      navigator.share({
        title: act.title,
        text: desc,
        url: act.data.page_url
      }).then(() => {
        this.$notice.info('Shared Successfully')
      }).catch(error => {
        this.$notice.error('Please try again later.')
      });
    },
    postType(act) {
        switch (act.type) {
            case "attachment":
                if(act.data) {
                    switch (act.data.attachment_type) {
                        case "video":
                            return 'Video Link';
                            break;
                        case "link":
                            return 'URL';
                            break;
                        case "slideshow":
                            return 'Slideshow';
                            break;
                        case "image":
                            return 'Image';
                            break;
                    }
                }
                break;
            case "trivia":
                if(act.data) {
                    switch (act.data.mode) {
                        case "true_or_false":
                            return 'TOF';
                            break;
                        case "checklist":
                            return 'Checklist';
                            break;
                        case 'multiple':
                            return 'Multiple Choice';
                            break;
                        case 'poll':
                            return 'Poll';
                            break;
                    }
                }
                break;
            case "reveal":
                return 'Question & Answer';
                break;
            case "recipe":
                return 'Recipe';
                break;
            case "apply_volunteer":
                var txt = '';
                if (act.data.permission == 503) txt = 'Admin'
                else if (act.data.permission == 99) txt = 'Moderator'
                else if (act.data.permission == 49) txt = 'Editor'
                else if (act.data.permission == 16) txt = 'Author'
                else if (act.data.permission == 1) txt = 'Member'
                return 'Applying for ' + txt + ':';
                break;
            default:
                return 'Article';
                break;
        }
    },
    bookmarkItem (item) {
      if( this.profileInfo.user_type !== 'guest') {
        this.$store.dispatch('feed/bookmarkItem', {item, type: this.section}).then(res => {
          if (!item.bookmarked) {
            item.bookmark_id = res.id
            item.bookmarked = 1
          } else {
            delete item.bookmark_id
            item.bookmarked = 0
          }
        }, err => {})
      } else {
        this.$store.commit('hitCheckpoint');
      }
    },
    viewActivity (item) {
      // if(this.isPublic) return false;
      this.$store.commit('feed/setSingleFeed', item)
      this.$router.push({ path: '/feed/' + item.id + "?scroll=false" })
    },
    viewResource (item) {
      if(this.isPublic) return false;
      if (this.section == 'journal' && this.section == 'group') { console.log('test') } else { this.$router.push({ path: '/resources/' + item.careplan.id }) }
    },
    titlePreview (item) {
      if (this.section == 'journal') { return item.poster.display_name } else { return item.title }
    },
    posterPreviewImage (item) {
      if (this.section == 'journal') { return item.poster.avatar } else { return item.careplan.thumbnail_photo[0]['small'] }
    },
    contentDisplay (act) {
      switch (act.type) {
        case 'user_post':
          if (act.data) return act.data.text
          break
        case 'passport_expiration':
          return 'Passport Expiration'
          break
        case 'contract_expiration':
          return 'Contract Expiration'
          break
        case 'attachment':
          if (act.data) {
            switch (act.data.attachment_type) {
              case 'video':
                if (act.data.text || act.data.preview_summary) { return act.data.text || act.data.preview_summary }
                break
              case 'link':
                if (act.data.text || act.data.preview_summary) { return act.data.text || act.data.preview_summary }
                break
              default:
                if (act.data.text) return act.data.text
                break
            }
          }
          break
        case 'trivia':
          if (act.data && act.data.question) return act.data.question
          break
        case 'reveal':
          if (act.data && act.data.question) return act.data.question
          break
        case 'recipe':
          if (act.data && act.data.description) { return '<a>View Recipe</a>' }
          break
        case 'video': 
          if (act.data && act.data.text) { return act.data.text }
          break
        default:
          if (act.data && act.data.tip) { return act.data.tip.replace(/(<([^>]+)>)/gi, '') }
          break
      }
      return ''
    },
    postPreviewImage (act) {
      if (act.cover_photo && act.cover_photo.length > 0 && 'medium' in act.cover_photo[0]) {
        return act.cover_photo[0]['medium']
      }
    },
    onWindowScrolledBottom () {
      if (this.section == 'journal') {
        if (this.$store.state.user.journalFeed.list.next_link && !this.$store.state.user.journalFeed.isLoading)
        {
          this.$store.dispatch('user/getJournalFeedMore', { url: this.$store.state.user.journalFeed.list.next_link })
        }
      } else if (this.section == 'group') {
        if (this.$store.state.resource.groupFeed.list.next_link && !this.$store.state.resource.groupFeed.isLoading) { this.$store.dispatch('resource/getGroupFeedMore', { url: this.$store.state.resource.groupFeed.list.next_link }) }
      } else {
        if (this.$store.state.user.feed.list.next_link && !this.$store.state.user.feed.isLoading) { this.$store.dispatch('user/getUserFeedMore', { url: this.$store.state.user.feed.list.next_link }) }
      }
    }
  },
  computed: {
    userIdCurrent: function() {
      return this.$store.state.user.info.id;
    },
    userIdPublic: function() {
      return this.$store.state.user.publicProfile.id;
    },
    publicProfile: {
      get() {
        return this.$store.state.user.publicProfile;
      }
    },
    profileInfo: {
      get () {
        return this.$store.state.user.info
      }
    },
    feed: {
      get () {
        if (this.section == 'journal') {
          return this.$store.state.user.journalFeed
        } else if (this.section == 'group') {
          return this.$store.state.resource.groupFeed
        } else {
          return this.$store.state.user.feed
        }
      }
    },
    orderedFeeds: function () {
      if (this.section == 'journal') {
        return _.orderBy(this.feed.list.careplan_item, 'rrule_parsed_date', 'desc')
      } else if (this.section == 'group') {
        return _.orderBy(this.feed.list.careplan_item, 'rrule_parsed_date', 'desc')
      } else {
        return _.orderBy(this.feed.list.items, 'rrule_parsed_date', 'desc')
      }
    }

  }
}
</script>
